import { Columns } from '@domain-group/suit-theme'

import usePortal from '@hooks/usePortal'

import PageLayout from '../../../../components/PageLayout'

import PortalAgencies from '../PortalAgencies'

const PageContent = (props: { portalId: number}) => {
  const { portalId } = props

  const portalPayload = usePortal({ id: portalId })

  return (
    <PageLayout entityPayload={portalPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        <PortalAgencies portalId={portalId} />
      </Columns.Main>
    </PageLayout>
  )
}

export default PageContent
